import axios from "axios";

axios.defaults.headers.post["Content-Type"] = "application/json";

const token = localStorage.getItem("user");
if (token) axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

axios.interceptors.response.use(null, (error) => {
  const expectedErrors =
    error.response &&
    error.response.status >= 400 &&
    error.response.status < 500;
  if (!expectedErrors) {
    console.log("somthing went wrong from server", error);
  }
  return Promise.reject(error);
});

export const http = {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete,
};
